import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
} from "@mui/material";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Delete from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { ACTIONS } from '../../../shared/constants';
import { useSnackbar } from 'notistack';

const AreaDetails = ({
  handleClose,
  handleSave,
  handleDelete,
  data,
  action
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [name, setName] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    setName(data?.[0]?.name || '');
  }, [data]);


   useEffect(() => {
      if(action == ACTIONS.DELETE) {
        setIsDisabled(true);
      } else {
        setIsDisabled(false);
      }
    }, [action]);

  const onSave = () => {
    if (!name.trim()) {
      enqueueSnackbar('El nombre es requerido', { variant: 'error' });
      return;
    }
    handleSave(data?.[0]?.areaId, name.trim());
  };

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Detalle Área
      </DialogTitle>
      <DialogContent>
        <Box mt={1}>
          <TextField
            label="Nombre"
            placeholder="Nombre"
            value={name}
            onChange={(e) => setName(e.target.value)}
            type="text"
            disabled={isDisabled}
            fullWidth
            required
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ m: 1 }}>
        {action !== ACTIONS.DELETE && (
          <Button
            color="primary"
            variant="contained"
            onClick={onSave}
            endIcon={<SaveIcon />}
          >
            {ACTIONS.SAVE}
          </Button>
        )}
        {action === ACTIONS.DELETE && (
          <Button
            color="error"
            variant="contained"
            onClick={() => handleDelete(data?.[0]?.areaId)}
            endIcon={<Delete />}
          >
            {ACTIONS.DELETE}
          </Button>
        )}
        <Button
          variant="outlined"
          onClick={() => handleClose(false)}
          endIcon={<CancelIcon />}
        >
          {ACTIONS.CANCEL}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AreaDetails;
